import React from "react";
import Popular from "../Components/Popular";
import Veggies from "../Components/Veggies";

const Home = () => {
  return (
    <div>
      <Popular />
      <Veggies />
    </div>
  );
};

export default Home;
